<template>
	<section :class="['text-align-center py-200', isLightTheme ? 'bg-color-white' : 'bg-color-content-primary']">
		<div class="container">
			<p
				v-if="props.heading"
				:class="['heading-6 mt-200 mb-200', isLightTheme ? 'text-color-content-secondary' : 'text-color-white']"
				>{{ props.heading }}</p
			>

			<div
				role="marquee"
				aria-label="Marquee of logos"
				:class="['marquee-track', { 'pb-200': !isFlat }]"
				:style="`--marquee-duration: 45s; --marquee-gap: 3.5rem; --marquee-mask-color: ${
					isLightTheme ? '#fff' : '#151513'
				}`"
			>
				<ul :class="`marquee-list ${isLightTheme ? 'logos-list' : 'logos-list--dark'}`">
					<li v-for="(logo, l) in partnerLogos" :key="l">
						<img :src="logo" alt="logo icon" />
					</li>
				</ul>
				<ul :class="`marquee-list ${isLightTheme ? 'logos-list' : 'logos-list--dark'}`" aria-hidden="true">
					<li v-for="(logo, l) in partnerLogos" :key="`logo-dupe-${l}`">
						<img :src="logo" alt="logo icon" />
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';

interface Props {
	theme?: 'light' | 'dark';
	heading?: string;
	isFlat?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	theme: 'light',
	heading: 'We partner with some of the biggest financial institutions in the world',
	isFlat: false
});

const isLightTheme = computed(() => {
	return props.theme === 'light';
});

const partnerLogos = computed(() => {
	const partnerLogos = [
		'logo-allianz.svg',
		'logo-capital-one.svg',
		'logo-citizens.svg',
		'logo-KeyBank.png',
		'logo-metlife.svg',
		'logo-png.svg',
		'logo-TD-Bank.svg',
		'logo-wells-fargo.svg'
	];
	return partnerLogos.map((logo) => `${appCloudfrontPath}/images/marketing-site/logos/${logo}`);
});
</script>

<style lang="scss" scoped>
.logos-list {
	img {
		max-height: 64px;
		max-width: 130px;
		// css filter for gray(70)
		filter: invert(62%) sepia(0%) saturate(0) hue-rotate(0) brightness(94%) contrast(100%);
	}

	&--dark {
		img {
			max-height: 64px;
			max-width: 130px;
			// css filter for gray(40)
			filter: invert(22%) sepia(6%) saturate(93%) hue-rotate(182deg) brightness(86%) contrast(87%);
		}
	}
}
</style>
